<template>
  <page>
    <lazy-div>
      <v-card>
        <v-toolbar dense color="grey lighten-3" flat>
          <v-icon v-if="newMode">mdi-plus</v-icon>
          <v-icon v-else-if="reviewMode">mdi-pencil</v-icon>
          <v-icon v-else-if="queryMode">mdi-magnify</v-icon>
          <v-toolbar-title v-if="newMode">Create New Vessel Details</v-toolbar-title>
          <v-toolbar-title v-else-if="reviewMode">Edit Vessel Details</v-toolbar-title>
          <v-toolbar-title v-else-if="queryMode">Query Vessel Details</v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <message :messages="messages"></message>
          <v-container fluid grid-list-lg>
            <!-- row 1 -->
            <v-layout row wrap>
              <v-flex xs6 v-if="newMode">
                <v-text-field
                  v-model="form.paramName"
                  :label="labels.paramName"
                  :error-messages="errors.collect('paramName')"
                  data-vv-name="paramName"
                  :data-vv-as="labels.paramName"
                  v-validate="'required|param|max:7'"
                ></v-text-field>
              </v-flex>
              <v-flex xs6 v-if="queryMode || reviewMode">
                <v-subheader class="queryLabel">{{ labels.paramName }}</v-subheader>
                <div class="queryValue">{{ form.paramName }}</div>
              </v-flex>
              <v-flex xs6 v-if="newMode || reviewMode">
                <v-text-field
                  v-model="form.vesselName"
                  :label="labels.vesselName"
                  :error-messages="errors.collect('vesselName')"
                  data-vv-name="vesselName"
                  :data-vv-as="labels.vesselName"
                  v-validate="'required|max:80|sanction:' + sanctionName1Error"
                  @change="valSanction(form.vesselName, '', 'sanctionName1Error')"
                ></v-text-field>
              </v-flex>
              <v-flex xs6 v-if="queryMode">
                <v-subheader class="queryLabel">{{ labels.vesselName }}</v-subheader>
                <div class="queryValue">{{ form.vesselName }}</div>
              </v-flex>
            </v-layout>

            <!-- row 2 -->
            <v-layout row wrap>
              <v-flex xs6 v-if="newMode || reviewMode">
                <v-text-field
                  v-model="form.vesselDesc"
                  :label="labels.vesselDesc"
                  :error-messages="errors.collect('vesselDesc')"
                  data-vv-name="vesselDesc"
                  :data-vv-as="labels.paramName"
                  v-validate="'required|max:50'"
                ></v-text-field>
              </v-flex>
              <v-flex xs6 v-if="queryMode">
                <v-subheader class="queryLabel">{{ labels.vesselDesc }}</v-subheader>
                <div class="queryValue">{{ form.vesselDesc }}</div>
              </v-flex>
              <v-flex xs6 v-if="newMode || reviewMode">
                <v-text-field
                  v-model="form.vesselOwner"
                  :label="labels.vesselOwner"
                  :error-messages="errors.collect('vesselOwner')"
                  data-vv-name="vesselOwner"
                  :data-vv-as="labels.vesselOwner"
                  v-validate="'max:40'"
                ></v-text-field>
              </v-flex>
              <v-flex xs6 v-if="queryMode">
                <v-subheader class="queryLabel">{{ labels.vesselOwner }}</v-subheader>
                <div class="queryValue">{{ form.vesselOwner }}</div>
              </v-flex>
            </v-layout>

            <!-- row 3 -->
            <v-layout row wrap>
              <v-flex xs6 v-if="newMode || reviewMode">
                <v-autocomplete
                  :label="labels.vesselAgent"
                  :items="vslAgentList"
                  v-model="form.vesselAgent"
                  item-text="value"
                  item-value="code"
                  data-vv-name="vesselAgent"
                  :data-vv-as="labels.vesselAgent"
                  :error-messages="errors.collect('vesselAgent')"
                ></v-autocomplete>
              </v-flex>
              <v-flex xs6 v-if="queryMode">
                <v-subheader class="queryLabel">{{ labels.vesselAgent }}</v-subheader>
                <div class="queryValue">{{ form.vesselAgent }}</div>
              </v-flex>
              <v-flex xs6 v-if="newMode || reviewMode">
                <v-text-field
                  v-model="form.yearBuilt"
                  :label="labels.yearBuilt"
                  :error-messages="errors.collect('yearBuilt')"
                  data-vv-name="yearBuilt"
                  :data-vv-as="labels.yearBuilt"
                  v-validate="'max:10'"
                ></v-text-field>
              </v-flex>
              <v-flex xs6 v-if="queryMode">
                <v-subheader class="queryLabel">{{ labels.yearBuilt }}</v-subheader>
                <div class="queryValue">{{ form.yearBuilt }}</div>
              </v-flex>
            </v-layout>

            <!-- row 4 -->
            <v-layout row wrap>
              <v-flex xs6 v-if="newMode || reviewMode">
                <v-autocomplete
                  :label="labels.vesselFlag"
                  :items="vslFlagList"
                  v-model="form.vesselFlagCode"
                  item-text="value"
                  item-value="code"
                  data-vv-name="vesselFlag"
                  :data-vv-as="labels.vesselFlag"
                  :error-messages="errors.collect('vesselFlag')"
                ></v-autocomplete>
              </v-flex>
              <v-flex xs6 v-if="queryMode">
                <v-subheader class="queryLabel">{{ labels.vesselFlag }}</v-subheader>
                <div class="queryValue">{{ form.vesselFlagCode }} - {{ form.vesselFlag }}</div>
              </v-flex>
              <v-flex xs6 v-if="newMode || reviewMode">
                <v-autocomplete
                  :label="labels.vesselClass"
                  :items="vslClassList"
                  v-model="form.vesselClassCode"
                  item-text="value"
                  item-value="code"
                  data-vv-name="vesselClass"
                  :data-vv-as="labels.vesselClass"
                  :error-messages="errors.collect('vesselClass')"
                ></v-autocomplete>
              </v-flex>
              <v-flex xs6 v-if="queryMode">
                <v-subheader class="queryLabel">{{ labels.vesselClass }}</v-subheader>
                <div class="queryValue">{{ form.vesselClassCode }} - {{ form.vesselClass }}</div>
              </v-flex>
            </v-layout>

            <!-- row 5 -->
            <v-layout row wrap>
              <v-flex xs6 v-if="newMode || reviewMode">
                <v-autocomplete
                  :label="labels.vesselType"
                  :items="vslTypeList"
                  v-model="form.vesselTypeCode"
                  item-text="value"
                  item-value="code"
                  data-vv-name="vesselType"
                  :data-vv-as="labels.vesselType"
                  :error-messages="errors.collect('vesselType')"
                ></v-autocomplete>
              </v-flex>
              <v-flex xs6 v-if="queryMode">
                <v-subheader class="queryLabel">{{ labels.vesselType }}</v-subheader>
                <div class="queryValue">{{ form.vesselTypeCode }} - {{ form.vesselType }}</div>
              </v-flex>
              <v-flex xs6 v-if="newMode || reviewMode">
                <v-autocomplete
                  :label="labels.vesselConstn"
                  :items="vslConstnList"
                  v-model="form.vesselConstnCode"
                  item-text="value"
                  item-value="code"
                  data-vv-name="vesselConstn"
                  :data-vv-as="labels.vesselConstn"
                  :error-messages="errors.collect('vesselConstn')"
                ></v-autocomplete>
              </v-flex>
              <v-flex xs6 v-if="queryMode">
                <v-subheader class="queryLabel">{{ labels.vesselConstn }}</v-subheader>
                <div class="queryValue">{{ form.vesselConstnCode }} - {{ form.vesselConstn }}</div>
              </v-flex>
            </v-layout>

            <!-- row 6 -->
            <v-layout row wrap>
              <v-flex xs6 v-if="newMode || reviewMode">
                <v-autocomplete
                  :label="labels.vesselEngMake"
                  :items="vslEngMakeList"
                  v-model="form.vesselEngMakeCode"
                  item-text="value"
                  item-value="code"
                  data-vv-name="vesselEngMake"
                  :data-vv-as="labels.vesselEngMake"
                  :error-messages="errors.collect('vesselEngMake')"
                ></v-autocomplete>
              </v-flex>
              <v-flex xs6 v-if="queryMode">
                <v-subheader class="queryLabel">{{ labels.vesselEngMake }}</v-subheader>
                <div class="queryValue">{{ form.vesselEngMakeCode }} - {{ form.vesselEngMake }}</div>
              </v-flex>
              <v-flex xs6 v-if="newMode || reviewMode">
                <v-autocomplete
                  :label="labels.vesselEngMod"
                  :items="vslEngModList"
                  v-model="form.vesselEngModCode"
                  item-text="value"
                  item-value="code"
                  data-vv-name="vesselEngMod"
                  :data-vv-as="labels.vesselEngMod"
                  :error-messages="errors.collect('vesselEngMod')"
                ></v-autocomplete>
              </v-flex>
              <v-flex xs6 v-if="queryMode">
                <v-subheader class="queryLabel">{{ labels.vesselEngMod }}</v-subheader>
                <div class="queryValue">{{ form.vesselEngModCode }} - {{ form.vesselEngMod }}</div>
              </v-flex>
            </v-layout>

            <!-- row 7 -->
            <v-layout row wrap>
              <v-flex xs6 v-if="newMode || reviewMode">
                <v-text-field
                  v-model="form.grt"
                  :label="labels.grt"
                  :error-messages="errors.collect('grt')"
                  data-vv-name="grt"
                  :data-vv-as="labels.grt"
                ></v-text-field>
              </v-flex>
              <v-flex xs6 v-if="queryMode">
                <v-subheader class="queryLabel">{{ labels.grt }}</v-subheader>
                <div class="queryValue">{{ form.grt }}</div>
              </v-flex>
              <v-flex xs6 v-if="newMode || reviewMode">
                <v-text-field
                  v-model="form.nrt"
                  :label="labels.nrt"
                  :error-messages="errors.collect('nrt')"
                  data-vv-name="nrt"
                  :data-vv-as="labels.nrt"
                ></v-text-field>
              </v-flex>
              <v-flex xs6 v-if="queryMode">
                <v-subheader class="queryLabel">{{ labels.nrt }}</v-subheader>
                <div class="queryValue">{{ form.nrt }}</div>
              </v-flex>
            </v-layout>

            <!-- row 8 -->
            <v-layout row wrap>
              <v-flex xs6 v-if="newMode || reviewMode">
                <v-text-field
                  v-model="form.dwt"
                  :label="labels.dwt"
                  :error-messages="errors.collect('dwt')"
                  data-vv-name="dwt"
                  :data-vv-as="labels.dwt"
                ></v-text-field>
              </v-flex>
              <v-flex xs6 v-if="queryMode">
                <v-subheader class="queryLabel">{{ labels.dwt }}</v-subheader>
                <div class="queryValue">{{ form.dwt }}</div>
              </v-flex>
              <v-flex xs6 v-if="newMode || reviewMode">
                <v-text-field
                  v-model="form.imoRefNo"
                  :label="labels.imoRefNo"
                  :error-messages="errors.collect('imoRefNo')"
                  data-vv-name="imoRefNo"
                  :data-vv-as="labels.imoRefNo"
                  v-validate="'max:40'"
                ></v-text-field>
              </v-flex>
              <v-flex xs6 v-if="queryMode">
                <v-subheader class="queryLabel">{{ labels.imoRefNo }}</v-subheader>
                <div class="queryValue">{{ form.imoRefNo }}</div>
              </v-flex>
            </v-layout>

            <!-- row 9 -->
            <v-layout row wrap>
              <v-flex xs6 v-if="newMode || reviewMode">
                <v-text-field
                  v-model="form.licenseNo"
                  :label="labels.licenseNo"
                  :error-messages="errors.collect('licenseNo')"
                  data-vv-name="licenseNo"
                  :data-vv-as="labels.licenseNo"
                  v-validate="'max:20'"
                ></v-text-field>
              </v-flex>
              <v-flex xs6 v-if="queryMode">
                <v-subheader class="queryLabel">{{ labels.licenseNo }}</v-subheader>
                <div class="queryValue">{{ form.licenseNo }}</div>
              </v-flex>
              <v-flex xs6 v-if="newMode || reviewMode">
                <v-text-field
                  v-model="form.engSerialNo"
                  :label="labels.engSerialNo"
                  :error-messages="errors.collect('engSerialNo')"
                  data-vv-name="engSerialNo"
                  :data-vv-as="labels.engSerialNo"
                  v-validate="'max:20'"
                ></v-text-field>
              </v-flex>
              <v-flex xs6 v-if="queryMode">
                <v-subheader class="queryLabel">{{ labels.engSerialNo }}</v-subheader>
                <div class="queryValue">{{ form.engSerialNo }}</div>
              </v-flex>
            </v-layout>

            <!-- row 10 -->
            <v-layout row wrap>
              <v-flex xs6 v-if="newMode || reviewMode">
                <v-text-field
                  v-model="form.length"
                  :label="labels.length"
                  :error-messages="errors.collect('length')"
                  data-vv-name="length"
                  :data-vv-as="labels.length"
                  v-validate="'max:20'"
                ></v-text-field>
              </v-flex>
              <v-flex xs6 v-if="queryMode">
                <v-subheader class="queryLabel">{{ labels.length }}</v-subheader>
                <div class="queryValue">{{ form.length }}</div>
              </v-flex>
              <v-flex xs6 v-if="newMode || reviewMode">
                <v-text-field
                  v-model="form.breath"
                  :label="labels.breath"
                  :error-messages="errors.collect('breath')"
                  data-vv-name="breath"
                  :data-vv-as="labels.breath"
                  v-validate="'max:20'"
                ></v-text-field>
              </v-flex>
              <v-flex xs6 v-if="queryMode">
                <v-subheader class="queryLabel">{{ labels.breath }}</v-subheader>
                <div class="queryValue">{{ form.breath }}</div>
              </v-flex>
            </v-layout>

            <!-- row 11 -->
            <v-layout row wrap>
              <v-flex xs6 v-if="newMode || reviewMode">
                <v-text-field
                  v-model="form.depth"
                  :label="labels.depth"
                  :error-messages="errors.collect('depth')"
                  data-vv-name="depth"
                  :data-vv-as="labels.depth"
                  v-validate="'max:20'"
                ></v-text-field>
              </v-flex>
              <v-flex xs6 v-if="queryMode">
                <v-subheader class="queryLabel">{{ labels.depth }}</v-subheader>
                <div class="queryValue">{{ form.depth }}</div>
              </v-flex>
              <v-flex xs6 v-if="newMode || reviewMode">
                <v-text-field
                  v-model="form.horsePower"
                  :label="labels.horsePower"
                  :error-messages="errors.collect('horsePower')"
                  data-vv-name="horsePower"
                  :data-vv-as="labels.horsePower"
                  v-validate="'max:10'"
                ></v-text-field>
              </v-flex>
              <v-flex xs6 v-if="queryMode">
                <v-subheader class="queryLabel">{{ labels.horsePower }}</v-subheader>
                <div class="queryValue">{{ form.horsePower }}</div>
              </v-flex>
            </v-layout>

            <!-- row 12 -->
            <v-layout row wrap>
              <v-flex xs6 v-if="newMode || reviewMode">
                <v-text-field
                  v-model="form.mds"
                  :label="labels.mds"
                  :error-messages="errors.collect('mds')"
                  data-vv-name="mds"
                  :data-vv-as="labels.mds"
                  v-validate="'max:10'"
                ></v-text-field>
              </v-flex>
              <v-flex xs6 v-if="queryMode">
                <v-subheader class="queryLabel">{{ labels.mds }}</v-subheader>
                <div class="queryValue">{{ form.mds }}</div>
              </v-flex>
              <v-flex xs6 v-if="newMode || reviewMode">
                <v-text-field
                  v-model="form.totalCrew"
                  :label="labels.totalCrew"
                  :error-messages="errors.collect('totalCrew')"
                  data-vv-name="totalCrew"
                  :data-vv-as="labels.totalCrew"
                  v-validate="'max:10'"
                ></v-text-field>
              </v-flex>
              <v-flex xs6 v-if="queryMode">
                <v-subheader class="queryLabel">{{ labels.totalCrew }}</v-subheader>
                <div class="queryValue">{{ form.totalCrew }}</div>
              </v-flex>
            </v-layout>

            <!-- row 13 -->
            <v-layout row wrap>
              <v-flex xs6 v-if="newMode || reviewMode">
                <v-text-field
                  v-model="form.manufName"
                  :label="labels.manufName"
                  :error-messages="errors.collect('manufName')"
                  data-vv-name="manufName"
                  :data-vv-as="labels.manufName"
                  v-validate="'max:40'"
                ></v-text-field>
              </v-flex>
              <v-flex xs6 v-if="queryMode">
                <v-subheader class="queryLabel">{{ labels.manufName }}</v-subheader>
                <div class="queryValue">{{ form.manufName }}</div>
              </v-flex>
            </v-layout>
          </v-container>
          <v-container fluid grid-list-lg>
            <v-layout>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ labels.createdBy }}</v-subheader>
                <div class="queryValue">{{ createdBy }}</div>
              </v-flex>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ labels.createdDate }}</v-subheader>
                <div class="queryValue">{{ formatDisplayDate(createdDate) }}</div>
              </v-flex>
            </v-layout>
            <v-layout v-if="reviewMode || queryMode">
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ labels.modifiedBy }}</v-subheader>
                <div class="queryValue">{{ modifiedBy }}</div>
              </v-flex>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ labels.modifiedDate }}</v-subheader>
                <div class="queryValue">{{ formatDisplayDate(modifiedDate) }}</div>
              </v-flex>
            </v-layout>
          </v-container>
          <v-container fluid grid-list-lg>
            <v-btn class="mr-2" color="error" @click="doCancel" :loading="submitting">
              <span>Cancel</span>
              <v-icon right dark>mdi-cancel</v-icon>
            </v-btn>
            <v-btn :disabled="queryMode" color="primary" dark @click="doSave" :loading="submitting">
              Save
              <v-icon right>mdi-content-save</v-icon>
            </v-btn>
          </v-container>
        </v-card-text>
        <v-spacer class="mt-2"></v-spacer>
        <template v-if="!newMode">
          <v-divider></v-divider>
          <vsl-voy :vsl="vsl" :detReview="detReview"></vsl-voy>
        </template>
      </v-card>

      <!--LYT Added: 2020-08-27  Sanction Partial Matched Names List -->
      <v-dialog v-model="showSanctionDialog" width="1280px">
        <sanction-partial-match-list :sanctionItems="sanctionPartialMatchItems" @close="showSanctionDialog = false"></sanction-partial-match-list>
      </v-dialog>
    </lazy-div>
  </page>
</template>

<script>
import MessageMixin from '@/mixins/message'
import { formatDisplayDate } from '@/utils/date'
import { expandURI } from '@/utils/ajax'
import VslVoy from './vesselVoy'
import { commonAjaxMixin } from '@/mixins/common/commonAjaxMixin'
import SanctionPartialMatchList from '@/components/core/common/dialog/SanctionPartialMatchList'

export default {
  data() {
    return {
      detReview: undefined,
      labels: {
        paramName: 'Vessel No',
        vesselName: 'Vessel Name',
        vesselDesc: 'Vessel Description',
        vesselOwner: 'Vessel Owner',
        vesselAgent: 'Vessel Agent',
        yearBuilt: 'Year Built',
        vesselFlag: 'Vessel Flag',
        vesselClass: 'Vessel Class',
        vesselType: 'Vessel Type',
        vesselConstn: 'Vessel Construction',
        vesselEngMake: 'Engine Make',
        vesselEngMod: 'Engine Model',
        grt: 'Gross Register Tonnage',
        nrt: 'Net Register Tonnage',
        dwt: 'Dead Weight Tonnage',
        imoRefNo: 'IMO Reference No',
        licenseNo: 'License No',
        engSerialNo: 'Engine Serial No',
        length: 'Length',
        breath: 'Breath',
        depth: 'Depth',
        horsePower: 'Horse Power',
        mds: 'Min. Discemable Signal (MDS)',
        totalCrew: 'Total No. of Crews',
        manufName: 'Manufacturer Name',
        createdBy: 'Created By',
        createdDate: 'Created Date',
        modifiedBy: 'Modified By',
        modifiedDate: 'Modified Date'
      },
      form: {
        paramName: '',
        vesselName: '',
        vesselDesc: '',
        vesselOwner: '',
        vesselAgent: '',
        yearBuilt: 0,
        vesselFlag: '',
        vesselClass: '',
        vesselType: '',
        vesselConstn: '',
        vesselEngMake: '',
        vesselEngMod: '',
        vesselFlagCode: 'NA',
        vesselClassCode: 'UC',
        vesselTypeCode: '0',
        vesselConstnCode: 'NA',
        vesselEngMakeCode: 'NA',
        vesselEngModCode: 'NA',
        grt: 0,
        nrt: 0,
        dwt: 0,
        imoRefNo: '',
        licenseNo: '',
        engSerialNo: '',
        length: '',
        breath: '',
        depth: '',
        horsePower: 0,
        mds: 0,
        totalCrew: 0,
        manufName: ''
      },
      submitting: false,
      newMode: false,
      queryMode: false,
      reviewMode: false,
      createdBy: this.$store.state.token.firstName + ' ' + this.$store.state.token.lastName,
      createdDate: new Date(),
      modifiedBy: '',
      modifiedDate: '',
      vslAgentList: [],
      vslFlagList: [],
      vslClassList: [],
      vslTypeList: [],
      vslConstnList: [],
      vslEngMakeList: [],
      vslEngModList: []
    }
  },
  methods: {
    formatDisplayDate(xDate) {
      return formatDisplayDate(xDate)
    },
    async doFetch() {
      const apiURI = this.$store.state.marineParam.menu.vslParam
      if (apiURI) {
        this.loading = true
        const expand = { paramKey: 'vslDet', paramString: this.objParam }
        this.$http
          .get(expandURI(apiURI, expand))
          .then((result) => {
            const { data } = result.data
            if (data) {
              this.form.paramName = data.vslParam.paramName
              this.detReview = this.modeParam
              this.form.vesselName = data.vslParam.paramType
              this.form.vesselDesc = data.vslParam.paramDesc
              this.form.vesselOwner = data.vslParam.vesOwn
              this.form.vesselAgent = data.vslParam.vesAgent
              this.form.yearBuilt = data.vslParam.yrBuilt
              this.form.vesselFlag = data.vslParam.vesFlag
              this.form.vesselClass = data.vslParam.vesCls
              this.form.vesselType = data.vslParam.vesType
              this.form.vesselConstn = data.vslParam.vesConstn
              this.form.vesselEngMake = data.vslParam.vesEngMake
              this.form.vesselEngMod = data.vslParam.vesEngMod
              this.form.vesselFlagCode = data.vslParam.vesFlagCode
              this.form.vesselClassCode = data.vslParam.vesClsCode
              this.form.vesselTypeCode = data.vslParam.vesTypeCode
              this.form.vesselConstnCode = data.vslParam.vesConstnCode
              this.form.vesselEngMakeCode = data.vslParam.vesEngMakeCode
              this.form.vesselEngModCode = data.vslParam.vesEngModCode
              this.form.grt = data.vslParam.grt
              this.form.nrt = data.vslParam.nrt
              this.form.dwt = data.vslParam.dwt
              this.form.imoRefNo = data.vslParam.imoRefNo
              this.form.engSerialNo = data.vslParam.vesEngNo
              this.form.licenseNo = data.vslParam.licenseNo
              this.form.mds = data.vslParam.mds
              this.form.length = data.vslParam.length
              this.form.breath = data.vslParam.breath
              this.form.depth = data.vslParam.depth
              this.form.horsePower = data.vslParam.hp
              this.form.totalCrew = data.vslParam.totCrew
              this.form.manufName = data.vslParam.manufName
              this.createdBy = data.vslParam.createdBy
              this.modifiedBy = data.vslParam.modifiedBy
              this.createdDate = data.vslParam.createdDate
              this.modifiedDate = data.vslParam.modifiedDate
            }
          })
          .catch((err) => {
            const { data } = err.response
            if (data) {
              this.message(data)
              this.fieldMessage(data)
            }
          })
      }
    },
    doCancel() {
      this.$router.push({ name: 'vslDet' })
    },
    doClose() {
      this.resetValidator()
      this.resetMessages()
      this.form.paramName = ''
      this.form.vesselName = ''
      this.form.vesselDesc = ''
      this.form.vesselOwner = ''
      this.form.vesselAgent = ''
      this.form.yearBuilt = 0
      this.form.vesselFlag = 'NA'
      this.form.vesselClass = 'UC'
      this.form.vesselType = '0'
      this.form.vesselConstn = 'NA'
      this.form.vesselEngMake = 'NA'
      this.form.vesselEngMod = 'NA'
      this.form.vesselFlagCode = ''
      this.form.vesselClassCode = ''
      this.form.vesselTypeCode = ''
      this.form.vesselConstnCode = ''
      this.form.vesselEngMakeCode = ''
      this.form.vesselEngModCode = ''
      this.form.grt = 0
      this.form.nrt = 0
      this.form.dwt = 0
      this.form.imoRefNo = ''
      this.form.licenseNo = ''
      this.form.engSerialNo = ''
      this.form.length = ''
      this.form.breath = ''
      this.form.depth = ''
      this.form.horsePower = 0
      this.form.mds = 0
      this.form.totalCrew = 0
      this.form.manufName = ''
      this.createdBy = ''
      this.createdDate = ''
      this.modifiedBy = ''
      this.modifiedDate = ''
    },
    doSave() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          if (this.newMode) {
            this.doCreate()
          } else {
            this.doUpdate()
          }
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async doCreate() {
      const apiURI = this.$store.state.marineParam.menu.createVsl
      if (apiURI) {
        const returnForm = {
          actionKey: 'vslDet',
          paramName: this.form.paramName,
          paramType: this.form.vesselName,
          paramDesc: this.form.vesselDesc,
          vesOwn: this.form.vesselOwner,
          vesAgent: this.form.vesselAgent,
          yrBuilt: this.form.yearBuilt,
          vesFlag: this.form.vesselFlagCode,
          vesCls: this.form.vesselClassCode,
          vesType: this.form.vesselTypeCode,
          vesConstn: this.form.vesselConstnCode,
          vesEngMake: this.form.vesselEngMakeCode,
          vesEngMod: this.form.vesselEngModCode,
          grt: this.form.grt,
          nrt: this.form.nrt,
          dwt: this.form.dwt,
          imoRefNo: this.form.imoRefNo,
          vesEngNo: this.form.engSerialNo,
          licenseNo: this.form.licenseNo,
          mds: this.form.mds,
          length: this.form.length,
          breath: this.form.breath,
          depth: this.form.depth,
          hp: this.form.horsePower,
          totCrew: this.form.totalCrew,
          manufName: this.form.manufName
        }
        this.$http
          .post(apiURI, returnForm)
          .then((result) => {
            const { data } = result
            if (data) {
              this.notify(data)
              this.doClose()
              this.doCancel()
            }
          })
          .catch((err) => {
            const { data } = err.response
            if (data) {
              this.message(data)
              this.fieldMessage(data)
            }
          })
      }
    },
    async doUpdate() {
      const apiURI = this.$store.state.marineParam.menu.updateVsl
      if (apiURI) {
        const returnForm = {
          actionKey: 'vslDet',
          paramName: this.form.paramName,
          paramType: this.form.vesselName,
          paramDesc: this.form.vesselDesc,
          vesOwn: this.form.vesselOwner,
          vesAgent: this.form.vesselAgent,
          yrBuilt: this.form.yearBuilt,
          vesFlag: this.form.vesselFlagCode,
          vesCls: this.form.vesselClassCode,
          vesType: this.form.vesselTypeCode,
          vesConstn: this.form.vesselConstnCode,
          vesEngMake: this.form.vesselEngMakeCode,
          vesEngMod: this.form.vesselEngModCode,
          grt: this.form.grt,
          nrt: this.form.nrt,
          dwt: this.form.dwt,
          imoRefNo: this.form.imoRefNo,
          vesEngNo: this.form.engSerialNo,
          licenseNo: this.form.licenseNo,
          mds: this.form.mds,
          length: this.form.length,
          breath: this.form.breath,
          depth: this.form.depth,
          hp: this.form.horsePower,
          totCrew: this.form.totalCrew,
          manufName: this.form.manufName
        }
        this.$http
          .post(apiURI, returnForm)
          .then((result) => {
            const { data } = result
            if (data) {
              this.notify(data)
              this.doClose()
              this.doCancel()
            }
          })
          .catch((err) => {
            const { data } = err.response
            if (data) {
              this.message(data)
              this.fieldMessage(data)
            }
          })
      }
    },
    doFetchVslAgentData() {
      const apiURI = this.$store.state.marineParam.menu.vesselParamList
      if (apiURI) {
        this.loading = true
        const expand = { paramKey: 'agent', paramString: '' }
        this.$http
          .get(expandURI(apiURI, expand))
          .then((result) => {
            const { data } = result.data
            if (data) {
              data.filter((list) => {
                this.vslAgentList.push({ code: list.paramName, value: list.paramName + ' - ' + list.paramDesc })
              })
            }
          })
          .catch((err) => {
            const { data } = err.response
            if (data) {
              this.message(data)
              this.fieldMessage(data)
            }
          })
      }
    },
    doFetchVslFlagData() {
      const apiURI = this.$store.state.marineParam.menu.vesselParamList
      if (apiURI) {
        this.loading = true
        const expand = { paramKey: 'vslFlag', paramString: '' }
        this.$http
          .get(expandURI(apiURI, expand))
          .then((result) => {
            const { data } = result.data
            if (data) {
              data.filter((list) => {
                this.vslFlagList.push({ code: list.paramName, value: list.paramName + ' - ' + list.paramDesc })
              })
            }
          })
          .catch((err) => {
            const { data } = err.response
            if (data) {
              this.message(data)
              this.fieldMessage(data)
            }
          })
      }
    },
    doFetchVslClassData() {
      const apiURI = this.$store.state.marineParam.menu.vesselParamList
      if (apiURI) {
        this.loading = true
        const expand = { paramKey: 'vslCls', paramString: '' }
        this.$http
          .get(expandURI(apiURI, expand))
          .then((result) => {
            const { data } = result.data
            if (data) {
              data.filter((list) => {
                this.vslClassList.push({ code: list.paramName, value: list.paramName + ' - ' + list.paramDesc })
              })
            }
          })
          .catch((err) => {
            const { data } = err.response
            if (data) {
              this.message(data)
              this.fieldMessage(data)
            }
          })
      }
    },
    doFetchVslTypeData() {
      const apiURI = this.$store.state.marineParam.menu.vesselParamList
      if (apiURI) {
        this.loading = true
        const expand = { paramKey: 'vslType', paramString: '' }
        this.$http
          .get(expandURI(apiURI, expand))
          .then((result) => {
            const { data } = result.data
            if (data) {
              data.filter((list) => {
                this.vslTypeList.push({ code: list.paramName, value: list.paramName + ' - ' + list.paramDesc })
              })
            }
          })
          .catch((err) => {
            const { data } = err.response
            if (data) {
              this.message(data)
              this.fieldMessage(data)
            }
          })
      }
    },
    doFetchVslConstnData() {
      const apiURI = this.$store.state.marineParam.menu.vesselParamList
      if (apiURI) {
        this.loading = true
        const expand = { paramKey: 'vslConstn', paramString: '' }
        this.$http
          .get(expandURI(apiURI, expand))
          .then((result) => {
            const { data } = result.data
            if (data) {
              data.filter((list) => {
                this.vslConstnList.push({ code: list.paramName, value: list.paramName + ' - ' + list.paramDesc })
              })
            }
          })
          .catch((err) => {
            const { data } = err.response
            if (data) {
              this.message(data)
              this.fieldMessage(data)
            }
          })
      }
    },
    doFetchVslEngMakeData() {
      const apiURI = this.$store.state.marineParam.menu.vesselParamList
      if (apiURI) {
        this.loading = true
        const expand = { paramKey: 'vslEngMake', paramString: '' }
        this.$http
          .get(expandURI(apiURI, expand))
          .then((result) => {
            const { data } = result.data
            if (data) {
              data.filter((list) => {
                this.vslEngMakeList.push({ code: list.paramName, value: list.paramName + ' - ' + list.paramDesc })
              })
            }
          })
          .catch((err) => {
            const { data } = err.response
            if (data) {
              this.message(data)
              this.fieldMessage(data)
            }
          })
      }
    },
    doFetchVslEngModData() {
      const apiURI = this.$store.state.marineParam.menu.vesselParamList
      if (apiURI) {
        this.loading = true
        const expand = { paramKey: 'vslEngMod', paramString: '' }
        this.$http
          .get(expandURI(apiURI, expand))
          .then((result) => {
            const { data } = result.data
            if (data) {
              data.filter((list) => {
                this.vslEngModList.push({ code: list.paramName, value: list.paramName + ' - ' + list.paramDesc })
              })
            }
          })
          .catch((err) => {
            const { data } = err.response
            if (data) {
              this.message(data)
              this.fieldMessage(data)
            }
          })
      }
    }
  },
  computed: {
    objVsl() {
      if (this.vsl !== undefined) {
        return true
      } else {
        return false
      }
    },
    menu() {
      return this.$store.state.marineParam.menu
    },
    modeParam() {
      return this.$route.params.vesselDetMode
    },
    objParam() {
      return this.$route.params.paramName
    }
  },
  watch: {
    vsl(value) {
      this.doFetch()
    }
  },
  mounted() {},
  created() {
    if (this.modeParam === 'create') {
      this.newMode = true
    } else if (this.modeParam === 'query') {
      this.queryMode = true
    } else {
      this.reviewMode = true
    }
    this.doFetch()
    this.doFetchVslAgentData()
    this.doFetchVslFlagData()
    this.doFetchVslClassData()
    this.doFetchVslTypeData()
    this.doFetchVslConstnData()
    this.doFetchVslEngMakeData()
    this.doFetchVslEngModData()
  },
  components: {
    VslVoy,
    SanctionPartialMatchList
  },
  mixins: [MessageMixin, commonAjaxMixin],
  props: ['vsl']
}
</script>
